module.exports = __webpack_public_path__ + "img/np_price_4162662_F0CD5E.b0c53e23.svg";